module.exports = __webpack_public_path__ + "static/img/202304.d255cc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/202304.jpg
// module id = JM9M
// module chunks = 0